module.exports = __webpack_public_path__ + "letterFadeInEnd.gif";